

export default {
  name: 'ExploreContainer',
  props: {
    name: String
  }
}
